module.exports = __webpack_public_path__ + "static/media/(H)_MG_5856_-_Cia_Termal_Beachewear_-_Moda_Feminina_-_Acessorios.a7a1772c.jpg";